define( [
	"./arr"
], function( arr ) {
	return arr.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/indexOf.js
// module id = 441
// module chunks = 352